import dayjs from 'dayjs';

export const getDateFromSeconds = (date: number | null, end?: boolean) => {
  if (date === null || Number.isNaN(date)) {
    return null;
  }
  let result = dayjs(date * 1e3);
  if (end) {
    result = result.endOf('day');
  }
  return result.toJSON();
};
